import React, { Fragment, useCallback, useState } from "react";

import banner8 from "../../assets/images/banner8.jpg";
import banner9 from "../../assets/images/banner9.png";
import { ButtonLink } from "../../components/ButtonLink/ButtonLink";
import { ConsultationBanner } from "../../components/ConsultationBanner/ConsultationBanner";
import { CourseProgramPopup } from "../../components/CourseProgramPopup/CourseProgramPopup";
import { FAQSection } from "../../components/FAQSection/FAQSection";
import { OutcomeSection } from "../../components/OutcomeSection/OutcomeSection";
import { ResultSection } from "../../components/ResultSection/ResultSection";
import { ReviewSection } from "../../components/ReviewSection/ReviewSection";
import { ServiceBannerSection } from "../../components/ServiceBannerSection/ServiceBannerSection";
import { TargetAudienceSection } from "../../components/TargetAudienceSection/TargetAudienceSection";
import { WorkflowSection } from "../../components/WorkflowSection/WorkflowSection";
import { faqData } from "../../config/faqData";
import { outcomeData } from "../../config/outcomeData";
import { resultData } from "../../config/resultData";
import { targetAudienceData } from "../../config/targetAudienceData";
import { workflowData } from "../../config/workflowData";
import { usePageData } from "../../hooks/usePageData";
import {
  Section,
  TitleH2,
} from "../../styles/sharedStyles";

import { Container, CustomTitleH2 } from "./styles"

const target = targetAudienceData.it_training_page
const workflow = workflowData.it_training_page
const result = resultData.it_training_page
const faq = faqData.it_training_page
const { outcome, backgroundImage } = outcomeData.it_training_page

export const ITTraining = () => {
  const { productCategories, reviews: filteredReviews } = usePageData(8);

  const [isProgramOpen, setIsProgramOpen] = useState(false)

  const handleOpenPopup = useCallback(() => setIsProgramOpen(true), [])
  const handleClosePopup = useCallback(() => setIsProgramOpen(false), [])

  return (
    <Fragment>
      <ServiceBannerSection
        mainText="Обучение профессии ИТ Рекрутер"
        backgroundImage={banner8}
        descText="Авторский курс Любови Прохоровой, который позволит не только обучиться профессии,
         но и устроиться на первую работу внутри обучения."
        whiteText={true}
      />
      <Section>
        <Container>
          <CustomTitleH2>Кому подходит <span>услуга?</span></CustomTitleH2>
          <TargetAudienceSection data={target} />
        </Container>
      </Section>
      <Section>
        <Container>
          <TitleH2>Как строится работа?</TitleH2>
          <WorkflowSection data={workflow} />
        </Container>
      </Section>
      <Section>
        <Container>
          <TitleH2>Что вы получите <span>в итоге ?</span></TitleH2>
          <OutcomeSection
            data={outcome}
            backgroundImage={backgroundImage}
            onButtonClick={handleOpenPopup}
          />
        </Container>
      </Section>
      <Section>
        <Container>
          <TitleH2>Мы приносим <span>результат</span></TitleH2>
          <ResultSection data={result} />
        </Container>
      </Section>
      <ConsultationBanner backgroundImage={banner9} />
      {filteredReviews.length > 0 && (
        <Section>
          <Container>
            <TitleH2>Отзывы</TitleH2>
            <ReviewSection
              reviews={filteredReviews}
              categories={productCategories}
            />
            <ButtonLink
              toPage="/reviews"
              title="Все отзывы"
            />
          </Container>
        </Section>
      )}
      <Section>
        <Container>
          <FAQSection data={faq} />
        </Container>
      </Section>
      <CourseProgramPopup
        isOpen={isProgramOpen}
        onClose={handleClosePopup}
      />
    </Fragment>
  )
}
